module.exports = __webpack_public_path__ + "img/quito.9015e634.jpg";